interface RouteValue {
  path: string
  isProtected?: boolean
  backPath?: string
}

const routes = {
  SELECT_ACCOUNT: {
    path: 'select-account/',
  },
  TIMED_OUT: {
    path: 'timed-out/',
  },
  UNDER_REVIEW: {
    path: 'under-review/',
  },
  ACCOUNT_EXISTS: {
    path: 'account-exists/',
  },
  DECLINE: {
    path: 'decline/',
  },
  DEVICE_NOT_SUPPORTED: {
    path: 'device-not-supported/',
  },
  ERROR: {
    path: 'error/',
  },
  LINK_EXPIRED: {
    path: 'link-expired/',
  },
  TECHNICAL_ISSUES: {
    path: 'technical-issues/',
  },
  UNABLE_VERIFY: {
    path: 'unable-to-verify/',
  },
} as const

// Record<string, RouteValue> doesn't suggest Route, so we need to define the following types to have keys suggested by TypeScript
type Routes = typeof routes
type RouteKey = keyof Routes
type Route = Record<RouteKey, RouteValue>
export const ROUTES = routes as Route
